import { lazy, Suspense } from "react";
import { Box } from "../../../common/components";
import { useStudio } from "../../../context/Studio/useStudio";
import ColorSelectorRightSidebarSkeleton from "./components/ColorSelectorRightSidebarSkeleton";
import DecorationRightSidebarSkeleton from "./DecorationRightSidebar/DecorationRightSidebarSkeleton";

const ColorSelectorRightSidebar = lazy(
  () => import("./components/ColorSelectorRightSidebar")
);
const DecorationRightSidebar = lazy(
  () => import("./DecorationRightSidebar/DecorationRightSidebar")
);

const StudioRightSidebar = () => {
  const {
    designState: {
      selection: { selectedPart },
    },
    isLoading,
  } = useStudio();

  if (isLoading) {
    return (
      <Box minWidth={{ xs: "100%", lg: 300 }}>
        <ColorSelectorRightSidebarSkeleton />
      </Box>
    );
  }
  return (
    <Box minWidth={{ xs: "100%", lg: 300 }}>
      {selectedPart === "Decoration" ? (
        <Suspense fallback={<DecorationRightSidebarSkeleton />}>
          <DecorationRightSidebar />
        </Suspense>
      ) : (
        <Suspense fallback={<ColorSelectorRightSidebarSkeleton />}>
          <ColorSelectorRightSidebar />
        </Suspense>
      )}
    </Box>
  );
};

export default StudioRightSidebar;
